import React, { Component } from 'react'
import { observer } from 'mobx-react'
import StoreAutoComplete from './StoreAutoComplete'

import Tags from '../../../stores/tags'

const compare = (a = '', b = '') => {
  return a.toLowerCase().trim() === b.toLowerCase().trim()
}

@observer
export default class AutoCompleteTags extends Component {

  constructor(...args) {
    super(...args)
    this.tags = new Tags()
    this.tags.load()
  }

  parseFetchedSuggestions = (suggestions, value) => {
    if (value && !this.tags.find(tag => compare(tag.label, value))) {
      suggestions.push({
        label: value,
        createNew: true
      })
    }
    return suggestions
  }

  renderSuggestion = suggestion => (
    <div>
      {suggestion.createNew ? (
        <em>Create Tag: </em>
      ) : null}
      <span>{suggestion.label}</span>
    </div>
  )

  fetchRecordFromSuggestion = suggestion => {
    return suggestion.createNew
      ? this.tags.create({ label: suggestion.label })
      : Promise.resolve(suggestion)
  }

  render() {
    const { name, onSelect, selected, clearAfterSelect, exclude } = this.props
    return (
      <StoreAutoComplete
        store={this.tags}
        parseFetchedSuggestions={this.parseFetchedSuggestions}
        fetchRecordFromSuggestion={this.fetchRecordFromSuggestion}
        renderSuggestion={this.renderSuggestion}
        name={name}
        exclude={exclude}
        selected={selected}
        onSelect={onSelect}
        placeholder="Add a Tag"
        clearAfterSelect={clearAfterSelect} />
    )
  }
}



// WEBPACK FOOTER //
// client/components/util/auto_complete/Tags.js